import React from 'react';

import styles from './Tooltip.module.css';

export const Tooltip = ({
  symbol,
  title,
  text,
  image
}: {
  symbol?: string;
  title: string;
  text: string;
  image?: any;
}) => {
  return (
    <div className={styles.tooltip}>
      {symbol || '?'}
      <div className={styles.tooltip}>
        <h6>{title}</h6>
        <p>{text}</p>
        {image && <img src={image} />}
      </div>
    </div>
  );
};
